import { render, staticRenderFns } from "./IWechat.vue?vue&type=template&id=2602a5e1&scoped=true&"
import script from "./IWechat.vue?vue&type=script&lang=js&"
export * from "./IWechat.vue?vue&type=script&lang=js&"
import style0 from "./IWechat.vue?vue&type=style&index=0&id=2602a5e1&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602a5e1",
  null
  
)

export default component.exports